import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { creditNumericValue } from '../credit/creditNumericValue'
import { creditProgramObject } from '../creditProgram/creditProgramObject'

export const creditBracketObject = z.object({
  id: z.string().uuid(),
  creditProgramId: creditProgramObject.shape.id,
  initialValue: creditNumericValue,
  finalValue: creditNumericValue.nullish(),
  percentage: creditNumericValue.nullish(),
  fixedValue: creditNumericValue.nullish(),
  maximumValue: creditNumericValue.nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const creditBracketCreateInputObject = creditBracketObject
  .pick({
    id: true,
    creditProgramId: true,
    initialValue: true,
    finalValue: true,
    percentage: true,
    fixedValue: true,
    maximumValue: true,
  })
  .extend({
    id: creditBracketObject.shape.id.nullish(),
  })
  .refine(input => input.percentage != null || input.fixedValue != null, {
    message: 'Informe percentual ou valor fixo',
    path: ['percentage'],
  })

export const creditBracketUpdateInputObject = creditBracketObject
  .pick({
    id: true,
    creditProgramId: true,
    initialValue: true,
    finalValue: true,
    percentage: true,
    fixedValue: true,
    maximumValue: true,
  })
  .partial()
  .required({ id: true })

export type CreditBracketType = z.infer<typeof creditBracketObject>

export const propertyMap = {
  id: sql`credit_bracket.id`,
  creditProgramId: sql`credit_bracket.credit_program_id`,
  initialValue: sql`credit_bracket.initial_value`,
  finalValue: sql`credit_bracket.final_value`,
  percentage: sql`credit_bracket.percentage`,
  fixedValue: sql`credit_bracket.fixed_value`,
  maximumValue: sql`credit_bracket.maximum_value`,
  createdAt: sql`credit_bracket.created_at`,
  updatedAt: sql`credit_bracket.updated_at`,
  deletedAt: sql`credit_bracket.deleted_at`,
}

export default creditBracketObject
